/**
 * TanStack Query hooks for `affiliate-referral-program-builder`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	affiliateReferralProgramBuilderQueryKeys,
	type CreateAffiliateReferralProgramBuilderBody,
	type ListAffiliateReferralProgramBuilderResponse,
	type AffiliateReferralProgramBuilderRow,
} from "./api";

export function useAffiliateReferralProgramBuilderList(): UseQueryResult<ListAffiliateReferralProgramBuilderResponse, Error> {
	return useQuery({
		queryKey: affiliateReferralProgramBuilderQueryKeys.list(),
		queryFn: list,
	});
}

export function useAffiliateReferralProgramBuilderCreate(): UseMutationResult<AffiliateReferralProgramBuilderRow, Error, CreateAffiliateReferralProgramBuilderBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: affiliateReferralProgramBuilderQueryKeys.all });
		},
	});
}

export function useAffiliateReferralProgramBuilderDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: affiliateReferralProgramBuilderQueryKeys.all });
		},
	});
}
